import React from "react";
import Tool from "../manager_tool";
import DataSender from "../../lib/ManagerDataSender";

class HealthInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // 유저 데이터값을 조회해서 건강 데이터값을 가져와야함
      items: [],
      allcheck: false,
      check: false,
    };
    this.ds = new DataSender();
    this.checkAll = this.checkAll.bind(this);
  }

  componentDidMount() {
    this.update();
  }

  update() {
    this.ds
      .getHealth()
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          items: res.map((x) => {
            x["checked"] = false;
            return x;
          }),
        });
      })
      .catch((err) => {});
  }

  checkboxclick = (e) => {
    let id = parseInt(e.target.getAttribute("tid"));

    let items = [...this.state.items];
    let item = { ...this.state.items[id], checked: e.target.checked };
    items[id] = item;

    this.setState({ items });
  };

  checkAll() {
    let check = !this.state.allcheck;
    this.setState({
      items: this.state.items.map((x) => {
        return { ...x, checked: check };
      }),
      allcheck: check,
    });
  }

  //===

  count(tis) {
    this.ds
      .getHealthCount()
      .then((res) => res.json())
      .then((res) => {
        tis.setState({ allperson: res.count });
      })
      .catch((err) => {});
  }

  deleteHealth() {
    let items = this.state.items.filter((x) => x.checked).map((x) => x.id);
    this.ds
      .deleteHealth({ items })
      .then(() => this.update())
      .catch((err) => {});
  }

  updateHealth(item) {
    if (item === undefined) {
      this.update();
      return;
    }
    item.alcohol = parseFloat(item.alcohol);
    item.pulse = parseInt(item.pulse);
    item.tempeture = parseFloat(item.tempeture);

    this.ds
      .updateHealth(item)
      .then(() => this.update())
      .catch((err) => {});
  }

  dateFormat(d) {
    var date = new Date(d);
    var year = date.getFullYear();
    if (isNaN(year)) return d;
    var month = ("0" + (1 + date.getMonth())).slice(-2);
    var day = ("0" + date.getDate()).slice(-2);
    var hour = ("0" + date.getHours()).slice(-2);
    var minutes = ("0" + date.getMinutes()).slice(-2);

    return year + "-" + month + "-" + day + "/" + hour + "-" + minutes;
  }

  //===

  render() {
    const items = this.state.items;

    return (
      <section>
        <div className="info02" style={{ width: "90%", marginLeft: "7%" }}>
          <div className="tb_w" style={{ width: "100%" }}>
            <h2>건강 상태</h2>
            <Tool
              item={this.state.items.find((x) => x.checked)}
              element={{
                tempeture: "온도",
                pulse: "맥박",
                alcohol: "음주",
                garments: "복장",
              }}
              delete={this.deleteHealth.bind(this)}
              update={this.updateHealth.bind(this)}
              count={this.count.bind(this)}
            />
            <table>
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      checked={this.props.allCheck}
                      onChange={this.checkAll.bind(this.measur)}
                    />
                  </th>
                  <th>이름</th>
                  <th style={{ padding: "5px" }}>전화번호</th>
                  <th>생년월일</th>
                  <th>군번</th>
                  <th>부대(소속)</th>
                  <th>
                    <b>체온</b>
                  </th>
                  <th>
                    <b>맥박</b>
                  </th>
                  <th>
                    <b>음주</b>
                  </th>
                  <th>
                    <b>복장</b>
                  </th>
                  <th>측정일자</th>
                </tr>
              </thead>
              <tbody>
                {/* table-row를 복사해야함 */}
                {items.map((x, i) => {
                  return (
                    <tr key={i}>
                      {/* 값이 있을때 checkbox가 보여야 함 */}
                      <td>
                        <input
                          id="check"
                          tid={i}
                          type="checkbox"
                          checked={x.checked}
                          onChange={this.checkboxclick}
                        />
                      </td>
                      <td className="col" data-label="이름">
                        {x.soldier.name}
                      </td>
                      <td
                        className="col"
                        data-label="전화번호"
                        style={{ padding: "5px" }}
                      >
                        {x.soldier.phone_number}
                      </td>
                      <td className="col" data-label="생년월일">
                        {x.soldier.birth}
                      </td>
                      <td className="col" data-label="군번">
                        {x.soldier.dt_number}
                      </td>
                      <td className="col" data-label="부대(소속)">
                        {x.soldier.army_unit.unitName}
                      </td>
                      <td className="col" data-label="온도">
                        <b>{x.tempeture}℃</b>
                      </td>
                      <td className="col" data-label="맥박">
                        <b>{x.pulse}</b>
                      </td>
                      <td className="col" data-label="음주">
                        <b>{x.alcohol}%</b>
                      </td>
                      <td className="col" data-label="복장">
                        <b>{x.garments ? "정상" : "비정상"}</b>
                      </td>
                      <td className="col" data-label="측정일자">
                        {this.dateFormat(x.create_date)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    );
  }
}

export default HealthInfo;
